import React, { useState } from "react";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../Config/Config";
import InputField from "../AssignTest/FormInputs";
import "./schedule.css";

function Schedules(dataClient) {
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [uploadClicked, setUploadClicked] = useState(false);
  const [processedData, setProcessedData] = useState([]);
  const [isCheckBox, setIsCheckBox] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState("");

  const client_id = dataClient.dataClient.client_schema_name[6][0].client_id;
  const clientBranchId =
    dataClient.dataClient.client_schema_name[6][0].client_branch_id;
  const user_name = dataClient.dataClient.client_schema_name[6][0].user_name;

  const handleFileUpload = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];
    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = XLSX.utils.sheet_to_json(
        workbook.Sheets[firstSheetName],
        { header: 1 }
      );
      // Filter out rows with empty cells
      const filteredData = worksheet.filter((row, index) => {
        if (index === 0) return true; // Keep the header row
        return row.every(
          (cell) => cell !== undefined && cell !== null && cell !== ""
        );
      });
      setExcelData(filteredData);
    };
    reader.readAsArrayBuffer(file);
  };

  const formatDate = (excelDate) => {
    if (isNaN(excelDate)) {
      return "";
    }
    const date = new Date((excelDate - (25567 + 2)) * 86400 * 1000);
    return format(date, "yyyy-MM-dd");
  };

  const formatTime = (excelTime) => {
    if (isNaN(excelTime)) {
      return "";
    }

    // console.log(excelTime);
    // console.log(Math.floor(excelTime), "floor");
    // console.log(Math.round(excelTime), "round");

    const totalMinutes = Math.round(excelTime * 24 * 60);
    // console.log(totalMinutes);
    const hours = Math.floor(totalMinutes / 60);
    // console.log(hours);
    const minutes = totalMinutes % 60;
    // console.log(minutes);
    const formattedTime = `${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}:00`;
    return formattedTime;
  };

  //THIS CODE IS FOR SHOWING TIME IN THE AM AND PM

  // const convertExcelTimeTo12HourFormat = (excelTime) => {
  //   const totalSeconds = excelTime * 24 * 60 * 60;
  //   const hours = Math.floor(totalSeconds / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = Math.floor(totalSeconds % 60);

  //   const period = hours >= 12 ? 'PM' : 'AM';
  //   const twelveHour = hours % 12 || 12;

  //   const formatted = `${twelveHour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${period}`;
  //   return formatted;
  // };

  // const handleUploadButtonClick = () => {
  //   if (excelData.length === 0) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Please upload an Excel file first",
  //       icon: "error",
  //       confirmButtonColor: "#318682",
  //     });
  //     return;
  //   }
  //   setUploadClicked(true);

  //   const data = excelData.slice(1).map((row) => ({
  //     date_: formatDate(row[1]),
  //     start_time: `${formatDate(row[1])} ${formatTime(row[2])}.000`,
  //     end_time: `${formatDate(row[1])} ${formatTime(row[3])}.000`,
  //     batch: row[4],
  //     subject: row[5],
  //     chapter: row[6],
  //     topic: row[7],
  //     faculty_name: row[8],
  //     batch_id: row[9],
  //     client_id: client_id,
  //     client_branch_id: clientBranchId,
  //     created_by: user_name,
  //   }));
  //   setProcessedData(data);
  // };

  const validateRow = (row, index) => {
    const errors = [];
    if (!row[1] || formatDate(row[1]) === "") {
      errors.push("Date is missing or invalid.");
    }
    if (!row[2] || formatTime(row[2]) === "") {
      errors.push("Start Time is missing or invalid.");
    }
    if (!row[3] || formatTime(row[3]) === "") {
      errors.push("End Time is missing or invalid.");
    }
    if (!row[4]) {
      errors.push("Batch Name is missing.");
    }
    if (!row[5]) {
      errors.push("Subject is missing.");
    }
    if (!row[8]) {
      errors.push("Faculty Name is missing.");
    }
    if (!row[9]) {
      errors.push("Batch ID is missing.");
    }
    return errors.length > 0 ? { index, errors } : null;
  };

  const handleUploadButtonClick = () => {
    if (excelData.length === 0) {
      Swal.fire({
        title: "Error",
        text: "Please upload an Excel file first",
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    const data = excelData.slice(1).map((row) => ({
      date_: formatDate(row[1]),
      start_time: `${formatDate(row[1])} ${formatTime(row[2])}.000`,
      end_time: `${formatDate(row[1])} ${formatTime(row[3])}.000`,
      batch: row[4],
      subject: row[5],
      chapter: row[6],
      topic: row[7],
      faculty_name: row[8],
      batch_id: row[9],
      client_id: client_id,
      client_branch_id: clientBranchId,
      created_by: user_name,
    }));

    // Validate each row of processed data
    const errors = excelData
      .slice(1)
      .map((row, index) => validateRow(row, index))
      .filter((result) => result !== null);

    if (errors.length > 0) {
      let errorMessage = "The following rows contain errors:\n";
      errors.forEach((error) => {
        errorMessage += `\nRow ${error.index + 1}: ${error.errors.join(", ")}`;
      });
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    setProcessedData(data);
    setUploadClicked(true);
  };

  const saveData = async () => {
    if (processedData.length === 0) {
      Swal.fire({
        title: "Error",
        text: "No data to save. Please upload and process an Excel file first.",
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    // Validate that end time is greater than start time
    const invalidEntries = processedData.filter((entry) => {
      const startTime = new Date(`${entry.start_time}`).getTime();
      const endTime = new Date(`${entry.end_time}`).getTime();
      return endTime <= startTime;
    });

    if (invalidEntries.length > 0) {
      Swal.fire({
        title: "Error",
        text: "End time must be greater than start time for all entries.",
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    if (isCheckBox && whatsAppNumber.trim() === "") {
      Swal.fire({
        title: "Error",
        text: "Please enter a WhatsApp number to send the timetable.",
        icon: "error",
        confirmButtonColor: "#318682",
      });
      return;
    }

    const url = isCheckBox
      ? `${API_BASE_URL}/coaching-collaborator-api/api/v1/create-time-table?whatsapp_number=${whatsAppNumber}`
      : `${API_BASE_URL}/coaching-collaborator-api/api/v1/create-time-table`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(processedData),
      });

      if (!response.ok) {
        throw new Error("Failed to save data");
      }

      Swal.fire({
        title: "Success",
        text: "All data saved successfully",
        icon: "success",
        confirmButtonColor: "#318682",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `Failed to save data: ${error.message}`,
        icon: "error",
        confirmButtonColor: "#318682",
      });
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const checkboxhandle = () => {
    setIsCheckBox(!isCheckBox);
  };

  const handleWhatsAppNumberChange = (event) => {
    setWhatsAppNumber(event.target.value);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Upload Class Time Table</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={saveData}>
            SAVE
          </button>
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Upload Time Table</h2>
          </div>
        </div>
        <div className="accordion-content">
          <div className="schedule-time-container">
            <div>
              <input
                type="file"
                accept=".xlsm"
                onChange={handleFileUpload}
                style={{ display: "none" }}
                id="excel-upload"
              />
              <label htmlFor="excel-upload">
                <button
                  className="upload-excel-button"
                  onClick={() =>
                    document.getElementById("excel-upload").click()
                  }
                >
                  Browse
                </button>
              </label>
              <input
                type="text"
                value={fileName}
                readOnly
                className="upload-excel-file-name"
              />
              {excelData.length > 0 && !uploadClicked && (
                <button
                  onClick={handleUploadButtonClick}
                  className="upload-excel-button"
                  style={{ marginLeft: "30px" }}
                >
                  Upload
                </button>
              )}
            </div>
          </div>
          {uploadClicked && (
            <div className="schedule-class-time">
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Batch Name</th>
                    <th>Subject</th>
                    <th>Chapter</th>
                    <th>Topic</th>
                    <th>Faculty Name</th>
                  </tr>
                </thead>
              </table>
              <div className="tbody-container">
                <table>
                  <tbody>
                    {excelData.slice(1).map((row, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{formatDate(row[1])}</td>
                        <td>{formatTime(row[2])}</td>
                        <td>{formatTime(row[3])}</td>
                        <td>{row[4]}</td>
                        <td>{row[5]}</td>
                        <td>{row[6]}</td>
                        <td>{row[7]}</td>
                        <td>{row[8]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Send Message</h2>
          </div>
        </div>
        <div className="accordion-content">
          <div className="schedule-time-container-checkbox">
            <div className="time-table-send-by-whatsapp">
              <input
                type="checkbox"
                className="cr-custom-checkbox"
                onChange={checkboxhandle}
              />
              <label>Send Time Table By WhatsApp</label>
            </div>
            {isCheckBox && (
              <div className="input-field-TT">
                <InputField
                  label="WhatsApp Number"
                  type="text"
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  required
                  value={whatsAppNumber}
                  onChange={handleWhatsAppNumberChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Schedules;
